import { Icon } from "@iconify/react/dist/iconify.js";
import "./css/header.css";

const QuizHeader = ({ actual, total, progreso }) => {
  const progresoRedondeado = Math.round(progreso);
  return (
    <div className="quiz-header">
      <div className="quiz-header-top">
        <button className="quiz-logo">
          <Icon icon="fluent:quiz-new-20-filled" />
          <span className="quiz-logo-text">Test de talentos</span>
        </button>

        <span className="quiz-progress-text">{progresoRedondeado}% completado</span>
      </div>

      <div className="progress-bar">
        <div className="progress-fill" style={{ width: `${progreso}%` }} />
      </div>
    </div>
  );
};

export default QuizHeader;
